<template>
  <div class="m-activity-seckill-detail">
    <el-row class="row-info">
      <el-col :span="2" class="col-label">活动名称</el-col>
      <el-col :span="22" class="col-value">{{ detailData.name }}</el-col>
    </el-row>
    <el-row class="row-info">
      <el-col :span="2" class="col-label">活动时间</el-col>
      <el-col :span="22" class="col-value">
        {{ detailData.startTime ? $moment(detailData.startTime).format('YYYY/MM/DD HH:mm') : '' }}
        {{ detailData.endTime ? ' - ' + $moment(detailData.endTime).format('YYYY/MM/DD HH:mm') : '' }}
      </el-col>
    </el-row>
    <el-row class="row-info">
      <el-col :span="2" class="col-label">发券场景</el-col>
      <el-col :span="22" class="col-value">{{ sceneMap[detailData.scene] }}</el-col>
    </el-row>
    <el-row class="row-info">
      <el-col :span="2" class="col-label">发券范围</el-col>
      <el-col :span="22" class="col-value">{{ useRangeMap[detailData.useRange] }}</el-col>
    </el-row>
     <el-row class="row-info" v-if="detailData.scene == 'AfterPay'">
      <el-col :span="2" class="col-label">参与限制</el-col>
        <el-col :span="22" class="col-value">
          <span v-if="detailData.userDaily === '1'">无限制</span>
          <span v-else>每人每天可参与{{ detailData.userDailyLimit }}次</span>
        </el-col>
    </el-row>
    <el-row class="row-info" v-if="detailData.scene == 'AfterPay'">
      <el-col :span="2" class="col-label">发券门槛</el-col>
      <el-col :span="22" class="col-value">订单实付金额满足{{ detailData.requireAmount }}元送券</el-col>
    </el-row>
    <el-row class="row-info">
      <el-col :span="2" class="col-label">优惠券</el-col>
      <el-col :span="22" class="col-value">
        <div class="coupon-table" style="margin-left: 0;">
          <Table
            :tableThData="tableThData_coupon"
            :tableTrData="detailData.couponTemplate"
            :pagination="false"
          >
            <template #name="{ row }">{{ row.name }}</template>
            <template #type="{ row }">{{ row.type }}</template>
            <template #detail="{ row }">{{ row.detail }}</template>
            <template #require="{ row }">{{ row.require }}</template>
            <template #useTime="{ row }">{{ row.useTime }}</template>
            <template #amount="{ row }">{{ row.amount }}</template>
          </Table>
        </div>
      </el-col>
    </el-row>
    <el-row class="row-info">
      <el-col :span="2" class="col-label">礼品券</el-col>
      <el-col :span="22" class="col-value">
        <div class="coupon-table" style="margin-left: 0;">
          <Table
            :tableThData="tableThData_gift"
            :tableTrData="detailData.giftCouponTemplate"
            :pagination="false"
          >
            <template #name="{ row }">{{ row.name }}</template>
            <template #subTitle="{ row }">{{ row.subTitle }}</template>
            <template #useTime="{ row }">{{ row.useTime }}</template>
            <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
            <template #description="{ row }">
              <el-button v-if="row.description" type="text" @click="onLookRemark(row)">查看使用须知</el-button>
              <span v-else>---</span>
            </template>
            <template #amount="{ row }">{{ row.amount }}</template>
          </Table>
        </div>
      </el-col>
    </el-row>
    <el-row class="row-info"  v-if="detailData.scene == 'AfterPay'">
      <el-col :span="2" class="col-label">停车券</el-col>
      <el-col :span="22" class="col-value">
        <div class="coupon-table" style="margin-left: 0;">
          <Table
            :tableThData="tableThData_parking"
            :tableTrData="detailData.lotCouponTemplate"
            :pagination="false"
          >
          <template #mallName="{ row }">{{ row.mallName }}</template>
          <template #name="{ row }">{{ row.name }}</template>
          <template #discount="{ row }">{{ row.discount }}</template>
          <template #validTime="{ row }">{{ row.validTime }}</template>
          <template #remark="{ row }">
            <el-button v-if="row.remark" type="text" @click="onLookRemark(row,'parking')">查看使用须知</el-button>
            <span v-else>---</span>
          </template>
            <template #amount="{ row }">{{ row.amount }}</template>
          </Table>
        </div>
      </el-col>
    </el-row>
    <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
      <div class="remark-box" v-html="currentRow.description"></div>
    </el-dialog>
  </div>
</template>

<script>
import Table from "@/components/Table/index";

export default {
  name: "marketActivitySeckillDetail",
  components: {
    Table,
  },
  props: {
    detailData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      tableThData_coupon: [
        { prop: "name", label: "优惠券名称", minWidth: "100", },
        { prop: "type", label: "优惠券类型", minWidth: "80", },
        { prop: "detail", label: "券优惠", minWidth: "100", },
        { prop: "require", label: "券门槛", minWidth: "80", },
        { prop: "useTime", label: "用券时间", minWidth: "110", },
        { prop: "amount", label: "数量", minWidth: "60", },
      ],
      tableThData_gift: [
        { prop: "name", label: "礼品券名称", minWidth: "120", },
        { prop: "subTitle", label: "标题", minWidth: "120", },
        { prop: "useTime", label: "券有效时间", minWidth: "100", },
        { prop: "useRangeType", label: "核销范围", minWidth: "80", },
        { prop: "description", label: "使用须知", minWidth: "120", },
        { prop: "amount", label: "数量", minWidth: "60", },
      ],
      tableThData_parking: [
        { prop: "name", label: "停车券名称", minWidth: "120", },
        { prop: "discount", label: "抵扣优惠", minWidth: "110", },
        { prop: "validTime", label: "券有效时间", minWidth: "160", },
        { prop: "mallName", label: "核销范围", minWidth: "180", },
        { prop: "remark", label: "使用须知", minWidth: "120", },
        { prop: "amount", label: "数量", minWidth: "60", },
      ],
      isShowRemarkDialog: false,
      currentRow: {},
      sceneMap: {
        AfterPay: '支付发券',
        Register: '注册发券'
      },
      useRangeMap: {
        Generic: '全场通用',
        Mall: '指定商场',
        Store: '指定店铺',
      }
    };
  },
  async created() {},
  methods: {
    // 查看使用须知
    onLookRemark(row,type) {
        this.currentRow = row
      if(type == 'parking'){
        this.currentRow.description = row.remark
      }
      this.isShowRemarkDialog = true
    },
  },
};
</script>

<style lang="scss" scoped>
.m-activity-seckill-detail {
  box-sizing: border-box;
  position: relative;

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .coupon-table {
    width: 90%;
    margin-left: 120px;
    margin-bottom: 20px;

    .table-price-box {
      display: flex;

      .text {
        height: 34px;
        line-height: 34px;
        margin: 0 10px;
      }
    }
  }


  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;
    }
  }

  .winning-record {
    margin-top: 60px;

    .el-divider {
      margin-bottom: 20px;
    }
  }
  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }

    .title-remark {
      color: #666666;
      font-size: 14px;
    }
  }

  .button-box{
    text-align: right;
  }
}
</style>
